import { render, staticRenderFns } from "./BitrixOAuthComplete.vue?vue&type=template&id=cf59055e&scoped=true"
import script from "./BitrixOAuthComplete.vue?vue&type=script&lang=js"
export * from "./BitrixOAuthComplete.vue?vue&type=script&lang=js"
import style0 from "./BitrixOAuthComplete.vue?vue&type=style&index=0&id=cf59055e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf59055e",
  null
  
)

export default component.exports